import { SEOCheckHelper } from "./helper/utilities";
import { defaultConfig as config } from "./config/defaultConfig";
import { customStyles } from "./helper/customStyles";

class SEOCheck extends HTMLElement {
    constructor() {
        // Always call super first in constructor
        super();
        try{
            this.colorGradient = [[1, 0.4, 0.08], [1, 0.55, 0.08], [0.98, 0.718, 0.2], [0.675, 0.702, 0.204], [0.412, 0.702, 0.298]]
            this.logo = `<svg xmlns="http://www.w3.org/2000/svg" width="143.607" height="24.105" viewBox="0 0 143.607 24.105">
                <g id="logo_grau_vollton" transform="translate(-168.7 -311.9)">
                    <path id="Pfad_103" data-name="Pfad 103" d="M168.7,331.228V312.2h3.114l7,15.871L185.68,312.2h2.986v19.028h-2.176V315.656l-6.741,15.572h-1.92l-6.869-15.572v15.572Z" transform="translate(0 -0.172)" fill="#9d8c45"/>
                    <path id="Pfad_104" data-name="Pfad 104" d="M240.7,321.642c0-6.442,3.2-9.642,9.557-9.642,6.272,0,9.386,3.2,9.386,9.642,0,6.4-3.114,9.6-9.386,9.6C243.857,331.241,240.7,328.042,240.7,321.642Zm9.514,7.637c4.522,0,6.826-2.56,6.826-7.68,0-5.077-2.261-7.594-6.826-7.594-4.65,0-6.954,2.517-6.954,7.594S245.606,329.279,250.214,329.279Z" transform="translate(-41.282 -0.057)" fill="#9d8c45"/>
                    <path id="Pfad_105" data-name="Pfad 105" d="M308.583,330.416v-2.261a18.732,18.732,0,0,0,6.442,1.067c3.285,0,4.906-1.195,4.906-3.584,0-2.048-1.195-3.072-3.626-3.072h-2.432c-3.968,0-5.973-1.749-5.973-5.205,0-3.626,2.56-5.461,7.637-5.461a22.133,22.133,0,0,1,6.186.811v2.261a17.3,17.3,0,0,0-6.186-1.067c-3.456,0-5.205,1.152-5.205,3.456,0,2.048,1.195,3.072,3.5,3.072h2.432c4.053,0,6.058,1.707,6.058,5.2,0,3.712-2.475,5.589-7.381,5.589A27.573,27.573,0,0,1,308.583,330.416Z" transform="translate(-79.812)" fill="#9d8c45"/>
                    <path id="Pfad_106" data-name="Pfad 106" d="M364.36,331.228H361.8l8.063-19.028h2.73l8.106,19.028h-2.73l-2.474-5.973h-6.272l.683-2.005h4.778l-3.541-8.618Z" transform="translate(-110.716 -0.172)" fill="#9d8c45"/>
                    <path id="Pfad_107" data-name="Pfad 107" d="M431.875,312.3v19.028H429.4V312.3Z" transform="translate(-149.475 -0.229)" fill="#9d8c45"/>
                    <path id="Pfad_108" data-name="Pfad 108" d="M460.9,321.642c0-6.442,3.2-9.642,9.557-9.642,6.272,0,9.386,3.2,9.386,9.642,0,5.29-2.133,8.447-6.442,9.386l3.072,3.584-1.92,1.451-4.138-4.821C464.1,331.241,460.9,328.042,460.9,321.642Zm9.557,7.637q6.784,0,6.784-7.68c0-5.077-2.261-7.594-6.784-7.594-4.65,0-6.954,2.517-6.954,7.594S465.806,329.279,470.457,329.279Z" transform="translate(-167.536 -0.057)" fill="#9d8c45"/>
                </g>
            </svg>`
            const wcParent = this.parentNode;
            this.checkHelper = new SEOCheckHelper(wcParent, config)
            // Create a shadow root
            this.shadow = this.attachShadow({ mode: 'open' });
            this.initDOM();
            this.doChecks();
        }
        catch(err){
            console.error(err)
        }
    }



    processResults(results) {
        let totalScore = 0;
        let maxScore = 0;
        let categoryScores = {};
        // display individual results
        for (const result of results) {
            const label = this.shadow.getElementById('seo-' + result.check)
            label.textContent = this.checkHelper.getTranslation(result.check, result.key, true)
            if(result.resultInfo){
                label.textContent += ' | '+result.resultInfo
            }

            const score = this.shadow.getElementById('seo-' + result.check + '-score')
            score.textContent = Math.round(result.multiplier * 100) + '%'
            const categoryScore = score.parentElement.parentElement.querySelector('.seo-category-score')
            categoryScore.textContent = Math.round(result.multiplier * 100) + '%'

            const color = this.checkHelper.getColorFromGradient(result.multiplier, this.colorGradient)
            label.parentElement.style['color'] = color
            label.parentElement.parentElement.style['color'] = color
            if(result.category){
                if(categoryScores[result.category]){
                    const cat = categoryScores[result.category]
                    cat.totalScore += result.multiplier * result.score
                    cat.maxScore += result.score
                }else{
                    categoryScores[result.category] = {}
                    const cat = categoryScores[result.category]
                    cat.totalScore = result.multiplier * result.score
                    cat.maxScore = result.score
                }
            }

            totalScore += result.multiplier * result.score
            maxScore += result.score
        }
        for(const [label, category] of Object.entries(categoryScores)){
            const cat = this.shadow.getElementById('seo-category-'+label)
            const color = this.checkHelper.getColorFromGradient(category.totalScore / category.maxScore, this.colorGradient)
            cat.style['color'] = color
            const categoryScore = cat.querySelector('.seo-category-score')
            categoryScore.textContent = Math.round(100 * category.totalScore / category.maxScore) + '%'
        }
        // calculate average and display color
        const avg = totalScore / maxScore
        const totalColor = this.checkHelper.getColorFromGradient(avg, this.colorGradient)
        this.shadow.querySelector('.seo-check-circle').style['background-color'] = totalColor
        const totalScoreEl = this.shadow.getElementById('seo-total-score')
        totalScoreEl.textContent = Math.round(100 * totalScore / maxScore) + '%'
        totalScoreEl.parentElement.style['color'] = totalColor
        // display score
        // shadow.querySelector('.seo-check-circle').textContent = Math.round(avg * 10)
    }

    async doChecks() {
        let functions = []
        for (const label in config.checks) {
            if (config.checks[label].enabled == true && (typeof this.checkHelper[label] === 'function')) {
                functions.push(this.checkHelper[label])
            }
        }
        const responses = await Promise.all(functions.map(fn => fn(this.checkHelper)))
        this.processResults(responses)
    }

    initDOM() {
        const style = document.createElement('style')
        style.textContent = customStyles;

        this.shadow.appendChild(style);

        const container = document.createElement('div');
        container.classList.add('seo-check')

        const circle = document.createElement('div');
        circle.classList.add('seo-check-circle')
        circle.addEventListener('click', () => {
            container.classList.toggle('seo-modal')
        })

        const title = document.createElement('div')
        title.classList.add('seo-title')
        title.textContent = this.checkHelper.getTranslation('general', 'title')
        title.addEventListener('click', () => {
            container.classList.toggle('seo-modal')
        })

        const header = document.createElement('div')
        header.classList.add('seo-header')

        const elements = document.createElement('div');
        elements.classList.add('seo-check-elements')

        // Append it to the shadow root
        header.appendChild(circle);
        header.appendChild(title);
        header.insertAdjacentHTML('beforeend',this.logo)
        container.appendChild(header);
        container.appendChild(elements);
        this.shadow.appendChild(container);

        for (const label in config.checks) {
            if (!config.checks[label].enabled) {
                continue;
            }
            const category = config.checks[label].category
            if (category && this.shadow.getElementById('seo-category-' + category)) {
                const el = this.shadow.getElementById('seo-category-' + category)
                const value = document.createElement('div');
                value.classList.add('seo-check-value');
                const valueLabel = document.createElement('div');
                valueLabel.id = 'seo-' + label;
                const score = document.createElement('div');
                score.classList.add('seo-check-score');
                score.id = 'seo-' + label + '-score';
                value.appendChild(valueLabel);
                value.appendChild(score);
                el.appendChild(value);
            } else {
                const icon = document.createElement('div');
                icon.textContent = '<'
                icon.classList.add('seo-check-icon')
                const title = document.createElement('div');
                title.classList.add('seo-check-title');
                title.textContent = this.checkHelper.getTranslation('categories', category, true)
                const el = document.createElement('div');
                el.classList.add('seo-check-element');
                if (category) {
                    el.id = 'seo-category-' + category
                }
                const categoryScore = document.createElement('div');
                categoryScore.classList.add('seo-category-score')
                const value = document.createElement('div');
                value.classList.add('seo-check-value');
                const valueLabel = document.createElement('div');
                valueLabel.id = 'seo-' + label;
                const score = document.createElement('div');
                score.classList.add('seo-check-score');
                score.id = 'seo-' + label + '-score';
                value.appendChild(valueLabel);
                value.appendChild(score);
                title.addEventListener('click', () => {
                    el.classList.toggle('seo-check-expanded')
                })
                title.appendChild(categoryScore)
                title.appendChild(icon)
                el.appendChild(title);
                el.appendChild(value);
                elements.appendChild(el);
            }
        }

        // create and append total score at the bottom
        const totalEl = document.createElement('div');
        totalEl.classList.add('seo-check-element');
        const totalLabel = document.createElement('div');
        totalLabel.classList.add('seo-check-title');
        totalLabel.textContent = this.checkHelper.getTranslation('general', 'total_score', true)
        const totalScore = document.createElement('div');
        totalScore.classList.add('seo-category-score')
        totalScore.id = 'seo-total-score'
        totalLabel.appendChild(totalScore);
        totalEl.appendChild(totalLabel);
        elements.appendChild(totalEl);
    }
}

// Define the new element
customElements.define('seo-check', SEOCheck);

